import { Action } from 'util/domain';
import { UploadStatus } from 'phoenix/domain';
import { UploadService } from 'phoenix/services';
import { PendingActionsService } from 'sharebase/services/pendingActionsService';
import { ToastService } from 'sharebase/services/toastService';
import { IFolderUploadService } from 'sharebase/services/folderUploadService';

/**
 * Manages displaying the upload progress component.
 */
export class UploadProgressDataStore {

    public static $inject: string[] = [
        'pxUploadService',
        'sbToastService',
        'sbFolderUploadService',
        'sbPendingActionsService',
        'gettextCatalog'
    ];

    private subscriptions: (() => void)[] = [];
    private panelRef;

    private readonly pendingMessage:string = this.gettextCatalog.getString('You have uploads in progress.'); 
    private resolvePendingStatus:Action;
    private resolveToast:Action;

    constructor(
        private readonly pxUploadService:UploadService,
        private readonly sbToastService:ToastService,
        private readonly sbFolderUploadService:IFolderUploadService,
        private readonly sbPendingActionsService:PendingActionsService,
        private readonly gettextCatalog:ng.gettext.gettextCatalog
    ) { }

    /**
     * Initialize the data store so that it begins listening to upload events.
     */
    public init(): void {
        this.subscriptions.push(this.pxUploadService.onStart(() => {
            // this.sbToastService.show(this.toastOpts);
            this.resolveToast = this.sbToastService.showProgressMessage({
                progressFn: () => this.pxUploadService.uploadStatus.percentCompleted,
                message: () => this.getMessage(),
                cancelFn: () => {
                    this.pxUploadService.cancelAllUploads();
                    this.sbFolderUploadService.cancelAllCurrentUploads();
                }
            });
            this.resolvePendingStatus = this.sbPendingActionsService.addMessage(this.pendingMessage, 'UPLOADS IN PROGRESS.');
        }));

        this.subscriptions.push(this.pxUploadService.onComplete(() => this.dispose(false)));
        this.subscriptions.push(this.pxUploadService.onCancel(() => this.dispose(false)));

    }

    public getMessage(): string {
        if(this.pxUploadService.uploadStatus.percentCompleted === 100) 
        {
            return this.gettextCatalog.getString('Uploading file {{filesInProcess}} of {{filesQueued}} ({{percentCompleted}}%), Upload Complete', this.pxUploadService.uploadStatus);

        } 
        else
        {
            return this.gettextCatalog.getString('Uploading file {{filesInProcess}} of {{filesQueued}} ({{percentCompleted}}%)', this.pxUploadService.uploadStatus);
        }
    }


    /**
     * Clears all upload event subscriptions.
     */
    public dispose(clearSubscriptions = true): void {
        if (this.resolvePendingStatus) {
            this.resolvePendingStatus();
        }

        if (this.resolveToast) {
            this.resolveToast();
        }
        
        if (clearSubscriptions) {
            this.subscriptions.forEach(sub => {
                if (typeof sub === 'function') {
                    sub();
                }
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/sharebase-app/dataStores/uploadProgressDataStore.ts